import { combineReducers } from "redux";

//--------------------- Autenticación ---------------------//
import loginReducer from "./auth/loginReducer";
import validaApiLoginReducers from "./auth/validaApiLoginReducers";

//--------------------- Registro de Inventario ---------------------//
// Formulario 1
import obtenerRecepcionReducers from "./Inventario/RegistrarInventario/obtenerRecepcionReducers";
import comboOrigenPresupuestoReducer from "./Inventario/Combos/comboOrigenReducers";
import comboModalidadCompraReducer from "./Inventario/Combos/comboModalidadReducers";
import comboProveedorReducers from "./Inventario/Combos/comboProveedorReducers";

// Formulario 2
import datosCuentaReducers from "./Inventario/RegistrarInventario/datosCuentaReducers";
import comboServicioReducer from "./Inventario/Combos/comboServicioReducers";
import comboCuentaReducer from "./Inventario/Combos/comboCuentaReducers";
import comboDependenciaReducer from "./Inventario/Combos/comboDependenciaReducers";

import detallesReducer from "./Inventario/Combos/comboDetallesReducers";

// Formulario 3
import datosActivoFijoReducers from "./Inventario/RegistrarInventario/datosActivoFijoReducers";

//--------------------- Modificar Inventario ---------------------//
// import datosInventarioReducers from "./Inventario/ModificarInventario/datosInventarioReducer";
import obtenerInventarioReducers from "./Inventario/ModificarInventario/obtenerInventarioReducers";
//--------------------- Anular Inventario ---------------------//
import listaInventarioAnularReducers from "./Inventario/AnularInventario/listaInventarioAnularReducers";
//--------------------- Registrar Altas ---------------------//
import obtenerEtiquetasAltasReducers from "./Altas/ImprimirEtiquetas/obtenerEtiquetasAltasReducers";
import obtenerfirmasAltasReducers from "./Altas/FirmarAltas/obtenerfirmasAltasReducers";
import obtenerUnidadesReducers from "./Altas/FirmarAltas/obtenerUnidadesReducers";

//--------------------- Registrar Bajas ---------------------//
import datosListadoGeneralBajasReducers from "./Bajas/datosListadoGeneralBajasReducers";
import obtenerListaRematesReducers from "./Bajas/datosListaRematesReducers";
import obtenerListaExcluidosReducers from "./Bajas/datosListaExcluidosReducers";

//--------------------- Bienes de Funcionarios ---------------------//
import datosBienesFuncionarioReducers from "./Inventario/BienesFuncionario/datosBienesFuncionarioReducers";

//--------------------- Indicadores ---------------------//
import indicadoresReducers from "./Otros/indicadoresReducers";

//--------------------- Modo Oscuro ---------------------//
import darkModeReducer from "./Otros/darkModeReducer";

//--------------------- Traslados ---------------------//
import comboTrasladoServicioReducer from "./Traslados/Combos/comboTrasladoServicioReducers";
import comboEstablecimientoReducer from "./Traslados/Combos/comboEstablecimientoReducer";
import comboTrasladoEspecieReducer from "./Traslados/Combos/comboTrasladoEspecieReducers";
import comboEstablecimientosProfileReducers from "./auth/loginPruebaReducers";
import comboDependenciaOrigenReducer from "./Traslados/Combos/comboDependenciaOrigenReducers";
import comboDependenciaDestinoReducer from "./Traslados/Combos/comboDependenciaDestinoReducers";
import listadoTrasladosReducers from "./Traslados/listadoTrasladosReducers";
//--------------------- Otros ---------------------//
import respuestaReducer from "./Otros/respuestaReducer";

//--------------------- Mantenedores ---------------------//
import obtenerMaxServicioReducers from "./Mantenedores/Servicios/obtenerMaxServicioReducers";
import listadoMantenedorDependenciasReducers from "./Mantenedores/Dependencias/listadoMantenedorDependenciasReducers";
import listadoMantenedorServiciosReducers from "./Mantenedores/Servicios/listadoMantenedorServiciosReducers";
import listadoMantenedorProveedoresReducers from "./Mantenedores/Proveedores/listadoMantenedorProveedoresReducers";
import listadoMantenedorEspeciesReducers from "./Mantenedores/Especies/listadoMantenedorEspeciesReducers copy";
import comboCuentaMantenedorReducers from "./Mantenedores/Especies/comboCuentaMantenedorReducers";
import listadoMantenedorComponentesReducers from "./Mantenedores/Componentes/listadoMantenedorComponentesReducers";
import obtenerMaxInventarioReducers from "./Inventario/RegistrarInventario/obtenerMaxInventarioReducers";
import comboServicioInformeReducers from "./Informes/Principal/FolioPorServicioDependencia/comboServicioInformeReducers";
import comboCuentasInformeReducers from "./Informes/Listados/comboCuentasInformeReducers";
import listaFolioServicioDependenciaReducers from "./Informes/Principal/FolioPorServicioDependencia/listaFolioServicioDependenciaReducers";
import listaCuentaFechasReducers from "./Informes/Principal/FechaCuentas/listaCuentaFechasReducers";
import listaActivosCalculadosReducers from "./Informes/Principal/CalcularDepreciacion/listaActivosCalculadosReducers";
import listaActivosFijosReducers from "./Informes/Principal/CalcularDepreciacion/listaActivosFijosReducers";
import listaActivosNoCalculadosReducers from "./Informes/Principal/CalcularDepreciacion/listaActivosNoCalculadosReducers";
import listaConsultaInventarioEspeciesReducers from "./Informes/Principal/ConsultaInventarioEspecies/listaConsultaInventarioEspeciesReducers";
import mostrarNPaginacionReducer from "./Otros/mostrarNPaginacionReducer";
import listaAltasReducers from "./Altas/AltasRegistradas/listaAltasReducers";
import listaAltasRegistradasReducers from "./Altas/AnularAltas/listaAltasRegistradasReducers";
import resumenInventarioRegistroReducers from "./Inventario/RegistrarInventario/resumenInventarioRegistroReducers";
import datosAltaRegistradaReducers from "./Altas/AltasRegistradas/datosAltaRegistradaReducers";
import listaVersionamientoReducers from "./Configuracion/listaVersionamientoReducers";
import obtenerServicioNombreReducers from "./Inventario/RegistrarInventario/obtenerServicioNombreReducers";
import listadoDeEspeciesBienReducers from "./Inventario/Combos/listadoDeEspeciesBienReducers";
import comboEspeciesBienReducers from "./Inventario/Combos/comboEspeciesBienReducers";
import obtenerInventarioTrasladoReducers from "./Traslados/obtenerInventarioTrasladoReducers";
import comboDependenciaModificarReducers from "./Inventario/Combos/comboDependenciaModificarReducers";
import comboCuentaModificarReducers from "./Inventario/Combos/comboCuentaModificarReducers";
import datosBajasRegistradaReducers from "./Bajas/datosBajasRegistradaReducers";
import obtieneVisadoCompletoReducers from "./Altas/EstadoFirmas/obtieneVisadoCompletoReducers";
import listaEstadoFirmasReducers from "./Altas/FirmarAltas/listaEstadoFirmasReducers";
import listaEstadoReducers from "./Altas/EstadoFirmas/listaEstadoReducers";
import listaEstadoVisadoresReducers from "./Altas/EstadoFirmas/listaEstadoVisadoresReducers";
import listaInventarioBuscarReducers from "./Inventario/BuscarInventario/listaInventarioBuscarReducers";
import setSidebarCollapsedReducer from "./Otros/setSidebarCollapsedReducer";
import obtenerInventarioQRReducers from "./Inventario/obtenerInventarioQRReducers";
import comboServicioMantenedorReducers from "./Mantenedores/Servicios/comboServicioMantenedorReducers";
import obtenerReimpresionEtiquetasAltasReducers from "./Altas/ImprimirEtiquetas/obtenerReimpresionEtiquetasAltasReducers";
import comboServDepReducers from "./Inventario/Combos/comboServDepReducers";
import obtenerInventarioXAltasReducers from "./Inventario/ModificarInventario/obtenerInventarioXAltasReducers";
import listadoTraspasosRecibidosReducers from "./Traspasos/listadoTraspasosRecibidosReducers";
import listadoTraspasosAdjuntosReducers from "./Traspasos/listadoTraspasosAdjuntosReducers";
import listadoBienesFuncionariosReducers from "./Inventario/BienesFuncionario/listadoBienesFuncionariosReducers";
import buscarBienesFuncionariosReducers from "./Inventario/BienesFuncionario/buscarBienesFuncionariosReducers";
import registrarDocumentoAltasReducers from "./Altas/FirmarAltas/registrarDocumentoAltasReducers";
import loginPruebaReducers from "./auth/loginPruebaReducers";
import listaActivosCalculadosPorCuentasReducers from "./Informes/Principal/CalcularDepreciacion/listaActivosCalculadosPorCuentasReducers";
import listaActivosNoCalculadosPorCuentasReducers from "./Informes/Principal/CalcularDepreciacion/listaActivosNoCalculadosPorCuentasReducers";
import listaActivosFijosPorCuentasReducers from "./Informes/Principal/CalcularDepreciacion/listaActivosFijosPorCuentasReducers";
import obtenerInventarioTraspasoReducers from "./Traspasos/obtenerInventarioTraspasoReducers";
import listaSalidaTraspasosReducers from "./Traspasos/listaSalidaTraspasosReducers";
import listaSalidaTrasladosReducers from "./Traslados/datosTrasladoRegistradoReducers";
import preferenciasReducers from "./Configuracion/preferenciasReducers";
import listaAltasModificarReducers from "./Altas/AnularAltas/listaAltasModificarReducers";
import listadoTrasladosAdjuntosReducers from "./Traslados/listadoTrasladosAdjuntosReducers";
import comboFuncionarioBEReducer from "./Bajas/comboFuncionarioBEReducer";
import filtroListadoTrasladosReducers from "./Traslados/filtroListadoTrasladosReducers copy";
import listadoTraspasosEnviadosReducers from "./Traspasos/listadoTraspasosEnviadosReducers";
import filtroListadoTraspasosEnviadosReducers from "./Traspasos/filtroListadoTraspasosEnviadosReducers";
import kpisReducers from "./Dashboard/kpisReducers";
import categoriaReducers from "./Dashboard/categoriaReducers";
import ubicacionReducers from "./Dashboard/ubicacionReducers";
import bajasReducers from "./Dashboard/bajasReducers";
import evolucionInventarioReducers from "./Dashboard/evolucionInventarioReducers";
import datosPersistidosReducers from "./Dashboard/datosPersistidosReducers";
import depreciacionInventarioReducers from "./Dashboard/depreciacionInventarioReducers";
import actualizarIndicadorHabilitadoReducers from "./Otros/actualizarIndicadorHabilitadoReducers";

//--------------------- Combinación de Reducers ---------------------//
const appReducer = combineReducers({
  // Autenticación
  loginReducer,
  loginPruebaReducers,
  validaApiLoginReducers,
  //-------------- Registro de Inventario----------------//
  // Formulario 1
  obtenerRecepcionReducers,
  comboOrigenPresupuestoReducer,
  comboModalidadCompraReducer,
  comboProveedorReducers,
  resumenInventarioRegistroReducers,
  obtenerServicioNombreReducers,

  // Formulario 2
  datosCuentaReducers,
  comboServicioReducer,
  comboCuentaReducer,
  comboDependenciaReducer,
  comboEspeciesBienReducers,//carga combo de especies
  listadoDeEspeciesBienReducers, //carga listado de especies
  detallesReducer,

  // Formulario 3
  datosActivoFijoReducers,
  obtenerMaxInventarioReducers,
  //-------------- Fin Registro de Inventario----------------//

  // Modificar Inventario
  obtenerInventarioReducers,
  obtenerInventarioXAltasReducers,
  comboDependenciaModificarReducers,
  comboCuentaModificarReducers,
  comboServDepReducers,

  // Anular Inventario
  listaInventarioAnularReducers,

  //Buscar Inventario
  listaInventarioBuscarReducers,

  //QR
  obtenerInventarioQRReducers,

  // Altas
  listaAltasReducers,
  listaAltasRegistradasReducers,
  obtenerEtiquetasAltasReducers,
  obtenerReimpresionEtiquetasAltasReducers,
  obtenerfirmasAltasReducers,
  obtenerUnidadesReducers,
  datosAltaRegistradaReducers,
  listaEstadoFirmasReducers,
  listaEstadoReducers,
  obtieneVisadoCompletoReducers,
  listaEstadoVisadoresReducers,
  registrarDocumentoAltasReducers,
  listaAltasModificarReducers,

  // Bajas
  datosListadoGeneralBajasReducers,
  datosBajasRegistradaReducers,
  obtenerListaRematesReducers,
  obtenerListaExcluidosReducers,
  comboFuncionarioBEReducer,

  // Bienes de Funcionarios
  datosBienesFuncionarioReducers,
  listadoBienesFuncionariosReducers,
  buscarBienesFuncionariosReducers,

  // Traslado
  obtenerInventarioTrasladoReducers,
  comboEstablecimientoReducer,
  comboTrasladoServicioReducer,
  comboTrasladoEspecieReducer,
  comboDependenciaOrigenReducer,
  comboDependenciaDestinoReducer,
  listadoTrasladosReducers,
  filtroListadoTrasladosReducers,
  listaSalidaTrasladosReducers,
  listadoTrasladosAdjuntosReducers,

  //Traspasos
  obtenerInventarioTraspasoReducers,
  listadoTraspasosEnviadosReducers,
  filtroListadoTraspasosEnviadosReducers,
  listadoTraspasosRecibidosReducers,
  listadoTraspasosAdjuntosReducers,
  listaSalidaTraspasosReducers,
  //-------Otros/Preferenicas---------------//
  // Indicadores
  indicadoresReducers,
  actualizarIndicadorHabilitadoReducers,
  // Modo Oscuro
  darkModeReducer,
  //Pregunta/Respuesta IA
  respuestaReducer,
  //guarda el numero de paginación
  mostrarNPaginacionReducer,
  //Menu Expandido
  setSidebarCollapsedReducer,
  //Versionamiento
  listaVersionamientoReducers,
  //Tiempo de sesion
  preferenciasReducers,

  //Informes
  comboServicioInformeReducers,
  comboCuentasInformeReducers,
  listaFolioServicioDependenciaReducers,
  listaCuentaFechasReducers,
  listaActivosFijosReducers,
  listaActivosFijosPorCuentasReducers,
  listaActivosCalculadosReducers,
  listaActivosNoCalculadosReducers,
  listaActivosCalculadosPorCuentasReducers,
  listaActivosNoCalculadosPorCuentasReducers,
  listaConsultaInventarioEspeciesReducers,

  //Mantenedores
  listadoMantenedorDependenciasReducers,
  listadoMantenedorServiciosReducers,
  listadoMantenedorProveedoresReducers,
  listadoMantenedorEspeciesReducers,
  listadoMantenedorComponentesReducers,
  comboEstablecimientosProfileReducers,
  obtenerMaxServicioReducers,
  comboCuentaMantenedorReducers,
  comboServicioMantenedorReducers,

  //Dashboard
  kpisReducers,
  categoriaReducers,
  ubicacionReducers,
  bajasReducers,
  evolucionInventarioReducers,
  depreciacionInventarioReducers,
  datosPersistidosReducers
});

//--------------------- Root Reducer ---------------------//
const rootReducer = (state: any, action: any) => {
  if (action.type === "LOGOUT") {
    // Reinicia el estado general a su valor inicial, solo mantiene el valor de darkModeReducer(Modo Oscuro)
    const { darkModeReducer, actualizarIndicadorHabilitadoReducers } = state || {};
    state = {
      darkModeReducer,
      actualizarIndicadorHabilitadoReducers
    };
  }

  //Esta funcion se encuentra en profile/configuraciones/datos
  if (action.type === "LIMPIAR_DATA") {
    //Se limpian todo los datos menos los listados aquí
    const {
      loginReducer,
      validaApiLoginReducers,
      comboOrigenPresupuestoReducer,
      comboModalidadCompraReducer,
      comboProveedorReducers,
      // comboServicioReducer,
      comboCuentaReducer,
      // comboDependenciaReducer,
      // comboListadoDeEspeciesBien,
      detallesReducer,
      comboEstablecimientoReducer,
      comboTrasladoServicioReducer,
      comboTrasladoEspecieReducer,
      comboServicioInformeReducers,
      indicadoresReducers,
      darkModeReducer,
      setSidebarCollapsedReducer,
      mostrarNPaginacionReducer,
      listaFolioServicioDependenciaReducers,
      listaCuentaFechasReducers,
      listaActivosFijosReducers,
      listaActivosCalculadosReducers,
      listaActivosNoCalculadosReducers,
      listaConsultaInventarioEspeciesReducers,
      listaVersionamientoReducers,
      obtenerUnidadesReducers,
      preferenciasReducers,
      actualizarIndicadorHabilitadoReducers
      // comboCuentasInformeReducers
    } = state || {};

    state = {
      loginReducer,
      validaApiLoginReducers,
      comboOrigenPresupuestoReducer,
      comboModalidadCompraReducer,
      comboProveedorReducers,
      // comboServicioReducer,
      comboCuentaReducer,
      // comboDependenciaReducer,
      // comboListadoDeEspeciesBien,
      detallesReducer,
      comboEstablecimientoReducer,
      comboTrasladoServicioReducer,
      comboTrasladoEspecieReducer,
      comboServicioInformeReducers,
      indicadoresReducers,
      darkModeReducer,
      setSidebarCollapsedReducer,
      mostrarNPaginacionReducer,
      listaFolioServicioDependenciaReducers,
      listaCuentaFechasReducers,
      listaActivosFijosReducers,
      listaActivosCalculadosReducers,
      listaActivosNoCalculadosReducers,
      listaConsultaInventarioEspeciesReducers,
      listaVersionamientoReducers,
      obtenerUnidadesReducers,
      preferenciasReducers,
      actualizarIndicadorHabilitadoReducers

      // comboCuentasInformeReducers
    };
  }
  return appReducer(state, action);
};

//--------------------- Exportación ---------------------//
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
